import type { SsoProvider } from '../../config';
import { SSO_BRAND } from '../../../../theme/tokens';

// Brand-glyph vector data for the SSO providers. Google + Telegram are the exact multi-colour brand
// marks. Brand fills come from the fixed SSO_BRAND tokens (theme/tokens.raw.ts): they are brand
// colours, not theme tokens, and must stay exact in both light and dark (SSO_BRAND is deliberately
// not run through themedValue). This is a plain `.ts` data module so the audited `.tsx` carries no
// colour literal (ProviderIcon renders these via `fill={path.fill}`).

export interface GlyphPath {
  d: string;
  fill: string;
}

export interface Glyph {
  viewBox: string;
  paths: GlyphPath[];
}

export const GLYPHS: Record<SsoProvider, Glyph> = {
  google: {
    viewBox: '0 0 19 19',
    paths: [
      {
        d: 'M17.86 9.69772C17.86 9.08022 17.8046 8.48647 17.7017 7.91647H9.5V11.289H14.1867C13.9808 12.3736 13.3633 13.2919 12.4371 13.9094V16.1023H15.2633C16.91 14.5823 17.86 12.3498 17.86 9.69772Z',
        fill: SSO_BRAND.googleBlue,
      },
      {
        d: 'M9.49975 18.2082C11.851 18.2082 13.8223 17.4324 15.2631 16.1024L12.4368 13.9095C11.661 14.432 10.6714 14.7486 9.49975 14.7486C7.23559 14.7486 5.31184 13.2207 4.62309 11.1624H1.72559V13.4107C3.1585 16.2528 6.09559 18.2082 9.49975 18.2082Z',
        fill: SSO_BRAND.googleGreen,
      },
      {
        d: 'M4.62314 11.1546C4.44897 10.6321 4.34606 10.078 4.34606 9.50005C4.34606 8.92214 4.44897 8.36797 4.62314 7.84547V5.59714H1.72564C1.13189 6.7688 0.791473 8.09089 0.791473 9.50005C0.791473 10.9092 1.13189 12.2313 1.72564 13.403L3.98189 11.6455L4.62314 11.1546Z',
        fill: SSO_BRAND.googleYellow,
      },
      {
        d: 'M9.49975 4.25897C10.7823 4.25897 11.9223 4.70231 12.8327 5.55731L15.3264 3.06356C13.8143 1.65439 11.851 0.791473 9.49975 0.791473C6.09559 0.791473 3.1585 2.74689 1.72559 5.59689L4.62309 7.84522C5.31184 5.78689 7.23559 4.25897 9.49975 4.25897Z',
        fill: SSO_BRAND.googleRed,
      },
    ],
  },
  telegram: {
    viewBox: '0 0 19.2 19.2',
    paths: [
      {
        d: 'M9.6 0C4.2984 0 0 4.2984 0 9.6C0 14.9016 4.2984 19.2 9.6 19.2C14.9016 19.2 19.2 14.9016 19.2 9.6C19.2 4.2984 14.9016 0 9.6 0ZM14.0496 6.5984L12.4176 14.2888C12.2976 14.8248 11.9856 14.9568 11.5424 14.7048L9.1424 12.9368L7.984 14.0504C7.856 14.1784 7.748 14.2864 7.5 14.2864L7.6728 11.8432L12.1256 7.8224C12.3192 7.6504 12.0832 7.5552 11.8264 7.7264L5.752 11.76L3.384 11.0208C2.8688 10.8608 2.8584 10.5056 3.492 10.2584L12.732 6.696C13.1616 6.5408 13.5368 6.8 13.2496 7.3984L14.0496 6.5984Z',
        fill: SSO_BRAND.telegramBlue,
      },
    ],
  },
};
